/* eslint-disable import/no-cycle */
/* eslint-disable no-case-declarations */
/* eslint-disable default-case */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
/* eslint-disable no-continue */
import { RepositoryResponse } from '@/types';
import { FilterOption } from '@/store/filter';
import filterService from '@/services/filterService';
import scholenRepository from './scholenRepository';
import stadsdelenRepository, { Stadsdeel } from './stadsdelenRepository';

export type FilterDataResponse = {
	data: {
		stadsdeel: Stadsdeel[];
	};
}

// extends the filterOptions array with the extra options since the count of
// extra options cannot come from the database, this value is set to -1
// indicating that it still needs to be computed
function extendFilterOptions(filterOptions: FilterOption[], extraOptions: Omit<FilterOption, 'count'>[]) {
	extraOptions.forEach((extraOption) => {
		filterOptions.push({ value: extraOption.value, count: -1, isInactive: extraOption.isInactive, parent: extraOption.parent });
	});
}

// Gets the possible values of a filterKey by doing a distinct query on the scholen
async function getDistinctScholenFilterOptions(filterKey: string):
	Promise<FilterOption[]> {
	return (await scholenRepository.listScholen({ [`fields[${filterKey}]`]: 'distinct' })).data;
}

export default {
	async listFilterData(): Promise<FilterDataResponse> {
		const stadsdeelData = (await stadsdelenRepository.listStadsdelen()).data;

		return {
			data: {
				stadsdeel: stadsdeelData,
			},
		};
	},
	async listFilterOptions(): Promise<RepositoryResponse> {
		let typeOptions = await getDistinctScholenFilterOptions('type');
		typeOptions = typeOptions.filter((t) => t.value !== 'voorschool');
		extendFilterOptions(typeOptions, filterService.extensions.type);

		const schooladviesOptions = [] as FilterOption[];
		extendFilterOptions(schooladviesOptions, filterService.extensions.schooladvies);

		const soortonderwijsOptions = [] as FilterOption[];
		extendFilterOptions(soortonderwijsOptions, filterService.extensions.soortonderwijs);

		const ondersteuningsaanbodOptions = [] as FilterOption[];
		extendFilterOptions(ondersteuningsaanbodOptions, filterService.extensions.ondersteuningsaanbod);

		const ondersteuningsSubaanbodOptions = [] as FilterOption[];
		extendFilterOptions(ondersteuningsSubaanbodOptions, filterService.extensions.ondersteunings_subaanbod);

		let stadsdeelOptions = await getDistinctScholenFilterOptions('stadsdeel');
		stadsdeelOptions = stadsdeelOptions.filter((option) => option.value);
		extendFilterOptions(stadsdeelOptions, filterService.extensions.stadsdeel);

		let denominatieOptions = await getDistinctScholenFilterOptions('denominatie');
		denominatieOptions = denominatieOptions.filter((option) => option.value);
		extendFilterOptions(denominatieOptions, filterService.extensions.denominatie);

		let onderwijsconceptOptions = await getDistinctScholenFilterOptions('onderwijsconcept');
		// MENNO: gebruik voor de onderwijsconcepten alleen het woordje voor de comma
		onderwijsconceptOptions = onderwijsconceptOptions.map((o) => {
			const { value, ...rest } = o;
			return {
				...rest,
				value: value.split(',')[0],
			};
		});
		onderwijsconceptOptions = onderwijsconceptOptions
			.filter((option) => option.value);

		const uniqueOnderwijsconceptOptions: FilterOption[] = [];
		onderwijsconceptOptions.forEach((o) => {
			if (!(uniqueOnderwijsconceptOptions.some((uo) => uo.value === o.value))) {
				uniqueOnderwijsconceptOptions.push(o);
			}
		});
		onderwijsconceptOptions = uniqueOnderwijsconceptOptions;

		extendFilterOptions(onderwijsconceptOptions, filterService.extensions.onderwijsconcept);

		const inspectieoordeelOptions = [] as FilterOption[];
		extendFilterOptions(inspectieoordeelOptions, filterService.extensions.inspectieoordeel);

		return {
			data: {
				type: typeOptions,

				schooladvies: schooladviesOptions,
				soortonderwijs: soortonderwijsOptions,

				stadsdeel: stadsdeelOptions,
				denominatie: denominatieOptions,
				onderwijsconcept: onderwijsconceptOptions,
				inspectieoordeel: inspectieoordeelOptions,
				ondersteuningsaanbod: ondersteuningsaanbodOptions,
				ondersteunings_subaanbod: ondersteuningsSubaanbodOptions
			},
		};
	},
};

/**
NOTES FROM MENNO:

[Inspectie oordelen]
"Er zijn verschillende mogelijkheden voor inspectieoordelen. De inspectie heeft helaas werkwijze
veranderd, eerst kon een school geloof ik zwak zijn, nu onvoldoende (of andersom). Helaas zijn de
beslisregels niet hetzelfde voor beide oordelen, reden waarom we ze niet vertalen naar
1 naam maar laten staan zoals ze zijn."

 Daarom twee hoofdsoorten:
- positief: 'voldoende', 'goed'
- negatief: 'onvoldoende', 'zwak', 'zeer zwak'
- eventueel derde soort (onbekend/nog geen oordeel)

TODO: Complicatie: wij hebben in cms nu 1 invoerveld per school ’inspectieoordeel’. Maar
eigenlijk oordeelt de inspectie in het VO per schoolsoort (mavo, havo, etc). In het PO nog wel
per school. In het MBO per opleiding (niet zijnde de locatie, als een instelling een opleiding
op meerdere adressen wordt aangeboden hoeft er maar eentje slecht te zijn om op alle plekken
negatief beoordeeld te worden). Omdat inspectie werkwijze regelmatig veranderd voorlopig tekstveld
aangehouden voor invoer. Gaat nu (dus) om het kunnen ’herkennen’ van de ingevulde info op
bovengenoemde positieve en negatieve beoordelingen.

[Denominaties]
"Alle particuliere scholen ’excluden’, alleen voor wie wil als optie in menu zetten.
Zie oude systeem. Vergelijkbaar principe met binnen en buiten amsterdam, buiten amsterdam ook
excluden tenzij als optie in scrollmenu gekozen."
*/
